import React from 'react';
import { HashLink as Link } from 'react-router-hash-link';
import routes from 'src/routes';
import Page from 'src/components/Page';
import Table from 'src/components/Table';
import ExpandDoc from 'src/components/ExpandDoc';

function ThreeDsPage() {
    return <Page header="3D Secure reference">
        
        <h2>ECI (Electronic Commerce Indicator) response codes</h2>
        <p>
            ECI code is a 3D Secure industry standard code.  Each scheme has their own code for different authentication outcomes.
        </p>     
        <h3>
            ECI code chart
        </h3>
        <Table
            headers={['Visa ECI', 'Mastercard ECI', 'Description']}
            body={[                
                [<code>07</code>, <code>00</code>, 'Authentication failed.'],
                [<code>06</code>, <code>01</code>, 'Authentication could not be completed, but transaction will be processed.'],
                [<code>05</code>, <code>02</code>, 'Cardholder authenticated.'],
            ]}
        />
        <p>ECI codes <code>01</code> and <code>06</code> could mean the issuing bank may not support 3D Secure.</p>
        <p><i>Note: The values may change depending on the locale or Issuer.</i></p>

        <h2>3D Secure Txn response</h2>
        <p>
            Once transaction is processed (<Link to={routes.api.spec + "#tag/TxnAuthkey/operation/TxnAuthkey_Process"}>Process transaction</Link>) a 3D Secure 
            result set is returned in the <code>Txn</code> object.  It contains additional information if 3D Secure is successful.            
        </p>
        <ExpandDoc method="Txn" doc={{
            isThreeDs: {
                type: 'boolean',
                description: "True if 3D Secure is enabled, otherwise false."
            },
            threeDsResult: {
                type: "object",
                description: "Contains one field property of Key/Value pairs",
                children: {
                    fields: {
                        type: "Array",
                        description: "Array of Key/Value pairs",
                        children: {
                            key: {
                                type: "string",
                                description: "Key can be one or more of the following: Eci, VerifyToken and Xid"
                            },
                            
                            value: {
                                type: "string",
                                description: "Result of 3D Secure"
                            },
                        }
                    }
                }
            }            
        }} />
        <p>
            Key/Value pairs are returned on successful 3D Secure transaction.
        </p>
        <Table
            headers={['Key', 'Value']}
            body={[
                [<code>Eci</code>, 'Electronic Commerce Indicator.'],
                [<code>VerifyToken</code>, 'The base64 encoded token generated by the card issuer.'],
                [<code>Xid</code>, 'A unique transaction identifier for the 3-D Secure authentication transaction.'],
            ]}
        />
        <p>
            Should transaction not be successful due to failed authentication, check the <code>responseText</code> for <code>Cardholder not authenticated</code> message.
        </p>
    </Page>;
}

export default ThreeDsPage;